// extracted by mini-css-extract-plugin
export default {"date":"inputDate_date__DLU3c"};